import React from 'react';
import { Content, Loader, Table } from 'rsuite';
// @ts-ignore
import { useCompetitividadeCidade } from '../../../hooks/useCompetitividadeCidade.tsx';
import CurrencyFormat from 'react-currency-format';
import { HoverTooltip } from '../../../../../components/HoverTooltip';
const { Column, HeaderCell, Cell } = Table;

type RowData = {
  fullCity: string;
  avg_average_competitivity_retail: string;
  count: number;
  isAboveAverage: boolean;
};

const columns = [
  {
    align: 'left',
    headerCell: 'Cidade',
    dataKey: 'fullCity',
    flexGrow: 2,
  },
  {
    align: 'left',
    headerCell: 'Competitividade',
    dataKey: 'avg_average_competitivity_retail',
    width: 80,
  },
  {
    align: 'right',
    headerCell: 'Itens',
    dataKey: 'count',
  },
  // @ts-ignore
] as Column<RowData>[];

export const CompetitividadeCidade: React.FC = () => {
  const { data, isLoading } = useCompetitividadeCidade();

  const competitividadeColor = (value: number) => {
    if (value > 105) return '#EC5B624D';
  };

  if (isLoading)
    return (
      <Content className="componente-tabela-loading">
        <Loader center />
      </Content>
    );

  if (!data || !data.length)
    return (
      <Content className="componente-tabela">
        <h2>Competitividade média por Cidade</h2>
        <div className="sem-dados">
          <h3>Sem dados para essa análise</h3>
          <p>Revise os filtros e tente novamente</p>
        </div>
      </Content>
    );

  return (
    <Content className="componente-tabela">
      <h2>Competitividade média por Cidade</h2>
      <div className="table-container">
        <Table data={data} height={385} rowHeight={32}>
          {columns.map((column, index) => (
            <Column key={index} {...column}>
              <HeaderCell className="header-tabela">
                {column.dataKey === 'avg_average_competitivity_retail' ? (
                  <HoverTooltip placement="bottom" text={column.headerCell} />
                ) : (
                  <span>{column.headerCell}</span>
                )}
              </HeaderCell>
              {column.dataKey === 'avg_average_competitivity_retail' ? (
                <Cell dataKey={column.dataKey}>
                  {(rowData: RowData) =>
                    rowData.avg_average_competitivity_retail ? (
                      <div
                        className="linha-tabela"
                        style={{
                          background: competitividadeColor(Number(rowData.avg_average_competitivity_retail.replace(',', '.'))),
                        }}
                      >
                        <CurrencyFormat
                          className="currency"
                          fixedDecimalScale
                          decimalScale={2}
                          value={rowData.avg_average_competitivity_retail}
                          displayType="text"
                          suffix="%"
                          decimalSeparator=","
                          thousandSeparator="."
                        />
                      </div>
                    ) : (
                      '--'
                    )
                  }
                </Cell>
              ) : (
                <Cell dataKey={column.dataKey}>{(rowData: RowData) => <div className="linha-tabela">{rowData[column.dataKey] || '--'}</div>}</Cell>
              )}
            </Column>
          ))}
        </Table>
      </div>
    </Content>
  );
};
